export function ConvertXMLIDToSefariaUrl(xmlID, errorMessage = null) {
	
	if (typeof xmlID !== "string") {
		
        if (errorMessage === null)
			throw "type error (xmlID must be a string) ";
		else
			return errorMessage;
	}
    
	let idParts = xmlID.split(".");
	let dotCount = idParts.length - 1;	
	
    // Currently applicable only for tanakh - will be changed later
    if (dotCount != 3 && dotCount != 4) {
        if (errorMessage === null)
			throw "value error (xmlID is in an inappropriate format [correct format: 'Tanakh.Torah.Genesis.18.18' or 'Tanakh.Prohpets.II_Samuel.18']) ";
		else
            return errorMessage;
	}
    
    const baseUrl = "https://www.sefaria.org/";
    const tradition = idParts[0].toLowerCase();
    
    if (tradition == "tanakh" || tradition == "tanach") {
        let bookChapterAndVerse = idParts.slice(2, idParts.length).join(".").split(" ").join("_");
        
        return baseUrl + bookChapterAndVerse;
		
	} else {
		
        if (errorMessage === null)
			throw "value error (only tanakh xml ids are supported currently) ";
		else
            return errorMessage;
	}
}